
import React, { useState, useContext, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { MapContext } from '../MapContext';
import { LayerContext } from '../LayerContext';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import './SideBar.css';

const DeleteAllButton = () => {

  const { map } = useContext(MapContext);
  const { layers, dispatch } = useContext(LayerContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [layerCheckbox, setLayerCheckbox] = useState(layers.map(layer => ({ layerId: layer.id, checked: true })));

  useEffect(() => {
    setLayerCheckbox(layers.map(layer => ({ layerId: layer.id, checked: true })));
  }, [layers, openDialog])

  const handleCheckboxChange = (event) => {
    const updatedCheck = layerCheckbox.map(layer => {
      if (layer.layerId === event.target.name) {
        return { layerId: layer.layerId, checked: !layer.checked };
      }
      return layer;
    });
    setLayerCheckbox(updatedCheck);
  }

  const handleDeleteAllLayers = () => {
    layers.map(layer => {
      if (layerCheckbox.find(item => item.layerId === layer.id)?.checked) {
        // delete multiple layers for gene group
        if (layer.assetType === "gene_group") {
          layer.subLayerIds?.map(layerId => map.current.removeLayer(layerId));
          layer.sourceId?.map(sourceId => map.current.removeSource(sourceId));
        } else {
          map.current?.removeLayer(layer.id);
          map.current?.removeSource(layer.sourceId);
        }
        dispatch({ type: 'DELETE_LAYER', payload: layer.id });
      }
    })
    setOpenDialog(false);
  }

  const handleOpenDialog = () => {
    layers && layers.length > 0 && setOpenDialog(true);
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <Button className="addAssetButton"
        startIcon={<DeleteForeverIcon />}
        onClick={handleOpenDialog}
      >
        Clear
      </Button>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm" // set maximum width to "md", "sm", "lg", or "xl"
        fullWidth={true} // makes the dialog take up the full width up to its maximum width
      >
        <DialogTitle>Delete all layers?</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
            {[...layers].reverse().map(layer => (
              <FormControlLabel
                key={`form-control-label-${layer.id}`}
                control={
                  <Checkbox
                    key={`check-box-${layer.id}`}
                    checked={layerCheckbox.find((item) => item.layerId === layer.id)?.checked}
                    onChange={handleCheckboxChange}
                    name={layer.id}
                  />
                }
                label={layer.assetType === "gene_group" ? `[${layer.assetType}] ${layer.title[0]} ...` : `[${layer.assetType}] ${layer.title}`}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="outlined" color="secondary">
            cancel
          </Button>
          <Button onClick={handleDeleteAllLayers} variant="outlined" color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteAllButton
